/// THIS FILE IS AUTOGENERATED!!! DO NOT EDIT MANUALLY!!!
/// INSTEAD, USE A VITE PLUGIN OR RUN `php artisan bridge:generate:enumerations` COMMAND.

export const CustomerType = {
  PERSONAL: 'personal',
  COMPANY: 'company',
  MEDICAL: 'medical',
} as const;

export type CustomerType = typeof CustomerType[keyof typeof CustomerType];
